var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgRedsiftPulse = function SvgRedsiftPulse(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 584 584",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 291.666,
    cy: 291.667,
    r: 291.667,
    style: {
      fill: "#e11010"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.524 174.147H204.64V457.61h-50V174.147h-.473v-49.87H387.499L287.322 290.943h-49.945l70.147-116.796Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.427 457.527-100.05-166.584h49.945l100.177 166.665-.098.001h-49.925l-.098-.001.049-.081Z",
    style: {
      fill: "#ffb3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.45 457.527 487.5 290.943h-49.945l-75.116 124.972 25.011 41.612Z",
    style: {
      fill: "#ff8181"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.45 124.359 487.5 290.943h-49.945l-75.116-124.972 25.011-41.612Z",
    style: {
      fill: "#e24e4e"
    }
  }));
};
export default SvgRedsiftPulse;